import React from 'react';
import { Link } from 'react-router-dom';

import DocsLayout, { pagerFor } from 'Containers/MCP/docs/DocsLayout';
import { MCP_RESOURCES, RESOURCE_COUNT } from 'data/mcpTools';

import './reference.scss';

const PATH = '/mcp/docs/resources';
const { prev: PREV, next: NEXT } = pagerFor(PATH);

const Resources = () => (
  <DocsLayout
    eyebrow="Using it"
    title="Resources"
    lede={
      <>
        Resources are read-only context the agent can pull in. Where a{' '}
        <Link to="/mcp/docs/tools">tool</Link> does something &mdash; writes a
        draft, updates a document, publishes a post &mdash; a resource only
        supplies information. Reading one never changes anything in your Vocable
        account.
      </>
    }
    stats={[
      { value: `${RESOURCE_COUNT}`, label: 'resources' },
      { value: 'Read-only', label: 'never writes' },
    ]}
    prev={PREV}
    next={NEXT}
  >
    <div className="mcp-ref">
      <div className="mcp-docs__callout mcp-docs__callout--tip">
        <p className="mcp-docs__callout-title">Claude decides when to read them</p>
        <p>
          You do not request resources by name. When your request needs brand
          context &mdash; the voice, the audience, the style rules &mdash; Claude
          reads the relevant resource first and then answers. You can nudge it
          (&ldquo;check the brand guidelines before you write&rdquo;), but you do
          not have to.
        </p>
      </div>

      <h2 id="brand-scope">Everything is scoped to the selected brand</h2>
      <p>
        Like tools, each resource returns data for whichever brand is currently
        active. Switch brands and the same resource returns that brand&rsquo;s
        profile, voice and guidelines instead. If you have more than one brand,
        confirm the right one is selected before you rely on what the agent
        tells you.
      </p>

      <h2 id="available-resources">Available resources</h2>
      <p>
        The names and URIs below come straight from the connector, so they always
        match what the agent can actually read.
      </p>

      <ul className="mcp-ref__resources">
        {MCP_RESOURCES.map((resource) => (
          <li key={resource.uri} className="mcp-ref__resource">
            <h3 id={`resource-${resource.name}`}>{resource.name}</h3>
            <span className="mcp-ref__resource-uri">{resource.uri}</span>
            <p className="mcp-ref__tool-desc">{resource.description}</p>
          </li>
        ))}
      </ul>

      <h2 id="empty-resource">If a resource comes back empty</h2>
      <p>
        A resource can only return what already exists in Vocable. If the agent
        reports that your voice DNA, content strategy or samples are missing,
        open that brand in the Vocable app and complete that part of your brand
        setup, then ask again. The{' '}
        <Link to="/mcp/docs/troubleshooting">troubleshooting guide</Link> covers
        the common cases.
      </p>
    </div>
  </DocsLayout>
);

export default Resources;
